import Base from '@studiometa/js-toolkit';

/**
 * ScrollTop class.
 */
export default class ScrollTop extends Base {
  /**
   * Class config
   * @return {Object}
   */
  static config = {
    name: 'ScrollTop',
  };

  /**
   * ScrollToTop on click
   * @return {void}
   */
  onClick() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
